<div class="col-sm-12">
    <div class="chart-title">
        <div class="recent-returns" [ngClass]="{'quarterly': dataType !== 'monthEndAvgAnnualRtn'}"><p class="rps-paragraph-two">Recent returns</p></div>
        <div class="average-annual" [ngClass]="{'quarterly': dataType !== 'monthEndAvgAnnualRtn'}"><p class="rps-paragraph-two">Average annual</p></div>
    </div>
    <div>
        <div class="chart-description">
            <canvas baseChart [datasets]="barChartData"
                              [labels]="barChartLabels"
                              [options]="barChartOptions"
                              [legend]="barChartLegend"
                              [type]="barChartType"
                              [attr.aria-label]="canvasAccessibleName"
                              role="img"
                              style="padding-left: 90px">
            </canvas>
        </div>
    </div>
</div>
